import { Button, Box, Collapse, IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, useTheme } from '@material-ui/core'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'
import LockIcon from '@material-ui/icons/Lock';
import React, { useMemo, useState } from 'react'
import { useRecoilValue } from 'recoil'
import { gregorianToJalali, thousandsSeparate, toFarsiDigits } from '../../assets/utils'
import { useReportFilter, ReportToolbar } from '../../assets/reportFilters'
import { exportExcelMulti, reportMetaNotes, fetchReportQr } from '../../assets/excelUtils'
import { transfersState } from '../../pages/contractor/atoms'
import { userInfoState } from '../../recoil/atoms'
import { LoadMoreButton, useIncrementalList } from '../../hooks/useIncrementalList'

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
})

const Row = props => {
    const classes = useRowStyles()
    const userInfo = useRecoilValue(userInfoState)
    const [detailExpand, setDetailExpand] = useState(false)
    const [documentExpand, setDocumentExpand] = useState(false)
    const data = props.data
    const detail = [...data.detail]
    const documents = [...data.documents]
    return (
        <>
            <TableRow className={classes.root}>
                <TableCell align='center'>
                    {!userInfo.is_subscribed ? <LockIcon /> :
                        <IconButton disabled={detail.length === 0} size='small' onClick={() => {
                            setDocumentExpand(false)
                            setDetailExpand(!detailExpand)
                        }}>
                            {detailExpand ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </IconButton>
                    }
                </TableCell>
                <TableCell align='center'>
                    {!userInfo.is_subscribed ? <LockIcon /> :
                        <IconButton disabled={documents.length === 0} size='small' onClick={() => {
                            setDetailExpand(false)
                            setDocumentExpand(!documentExpand)
                        }}>
                            {documentExpand ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </IconButton>
                    }
                </TableCell>
                <TableCell align='center'><strong>{toFarsiDigits(props.index)}</strong></TableCell>
                <TableCell align='center'>{toFarsiDigits(data.fiscal_year)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(data.number)}</TableCell>
                <TableCell align='center'>{gregorianToJalali(data.date)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(data.document_number)}</TableCell>
                <TableCell align='center'>{gregorianToJalali(data.document_date)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(data.request_number)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(data.request_type)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(data.remark)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(data.cash_or_document)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(data.treasury_document)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.amount))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.insurance))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.value_added_tax))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.prepayment))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.back_prepayment))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.service_life_prepayment))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.on_account))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.back_on_account))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.deduction_sum))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(data.receiver)}</TableCell>
            </TableRow>
            <TableRow className={classes.root} style={{ background: '#ecebeb' }}>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan='100%'>
                    <Collapse in={detailExpand} timeout='auto' unmountOnExit>
                        <Box margin={1}>
                            <Table size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='center'><strong>ردیف</strong></TableCell>
                                        <TableCell align='center'><strong>عنوان</strong></TableCell>
                                        <TableCell align='center'><strong>درصد</strong></TableCell>
                                        <TableCell align='center'><strong>مبلغ</strong></TableCell>
                                        <TableCell align='center'><strong>اسناد خزانه</strong></TableCell>
                                        <TableCell align='center'><strong>بودجه</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {detail.map((row, index) => (
                                        <TableRow key={row.id}>
                                            <TableCell align='center'><strong>{toFarsiDigits(index + 1)}</strong></TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.title)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.percent)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.amount))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.treasury_document)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.budget))}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                    <Collapse in={documentExpand} timeout='auto' unmountOnExit>
                        <Box margin={1}>
                            <Table size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='center'><strong>ردیف</strong></TableCell>
                                        <TableCell align='center'><strong>سال مالی سند</strong></TableCell>
                                        <TableCell align='center'><strong>شماره سند</strong></TableCell>
                                        <TableCell align='center'><strong>تاریخ سند</strong></TableCell>
                                        <TableCell align='center'><strong>حساب معین</strong></TableCell>
                                        <TableCell align='center'><strong>بدهکار</strong></TableCell>
                                        <TableCell align='center'><strong>بستانکار</strong></TableCell>
                                        <TableCell align='center'><strong>سال مالی حواله</strong></TableCell>
                                        <TableCell align='center'><strong>شماره حواله</strong></TableCell>
                                        <TableCell align='center'><strong>تاریخ حواله</strong></TableCell>
                                        <TableCell align='center'><strong>شماره صورت وضعیت</strong></TableCell>
                                        <TableCell align='center'><strong>نوع صورت وضعیت</strong></TableCell>
                                        <TableCell align='center'><strong>شماره چک</strong></TableCell>
                                        <TableCell align='center'><strong>تاریخ صدور چک</strong></TableCell>
                                        <TableCell align='center'><strong>تاریخ وصول چک</strong></TableCell>
                                        <TableCell align='center'><strong>مبلغ چک</strong></TableCell>
                                        <TableCell align='center'><strong>حساب گیرنده وجه</strong></TableCell>
                                        <TableCell align='center'><strong>شرح پرداخت</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {documents.map((row, index) => (
                                        <TableRow key={row.id}>
                                            <TableCell align='center'><strong>{toFarsiDigits(index + 1)}</strong></TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.fiscal_year)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.number)}</TableCell>
                                            <TableCell align='center'>{gregorianToJalali(row.date)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.account_subcoding)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.debtor)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.creditor)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.transfer_fiscal_year)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.transfer_number)}</TableCell>
                                            <TableCell align='center'>{gregorianToJalali(row.transfer_date)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.request_number)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.request_type)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.cheque_number)}</TableCell>
                                            <TableCell align='center'>{gregorianToJalali(row.cheque_date)}</TableCell>
                                            <TableCell align='center'>{gregorianToJalali(row.cheque_collected_date)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.cheque_amount))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.account_number)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.remark)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    )
}

/** خروجی اکسل حوالهها — برگهای: حوالهها، جزئیات، اسناد حسابداری */
const exportTransfersExcel = async (contract, transfers) => {
    const qr = contract && contract.id ? await fetchReportQr(contract.id) : null

    const main = {
        caption: 'حواله‌ها',
        headers: ['ردیف', 'سال مالی', 'شماره حواله', 'تاریخ', 'شماره سند حسابداری', 'تاریخ سند حسابداری', 'شماره صورت وضعیت', 'نوع صورت وضعیت', 'شرح', 'نقد/اسناد', 'اسناد خزانه', 'مبلغ', 'بیمه', 'مالیات بر ارزش افزوده', 'پیش پرداخت', 'تسویه پیش پرداخت جاری', 'تسویه پیش پرداخت سنواتی', 'علی الحساب', 'تسویه علی الحساب', 'جمع کسورات', 'گیرنده'],
        rows: transfers.map((t, i) => [
            i + 1,
            toFarsiDigitValue(t.fiscal_year),
            toFarsiDigitValue(t.number),
            gregorianToJalali(t.date),
            toFarsiDigitValue(t.document_number),
            gregorianToJalali(t.document_date),
            toFarsiDigitValue(t.request_number),
            toFarsiDigitValue(t.request_type),
            t.remark,
            t.cash_or_document,
            t.treasury_document,
            t.amount,
            t.insurance,
            t.value_added_tax,
            t.prepayment,
            t.back_prepayment,
            t.service_life_prepayment,
            t.on_account,
            t.back_on_account,
            t.deduction_sum,
            t.receiver,
        ]),
    }

    const details = {
        caption: 'جزئیات کسورات هر حواله',
        headers: ['شماره حواله', 'تاریخ حواله', 'عنوان', 'درصد', 'مبلغ', 'اسناد خزانه', 'بودجه'],
        rows: [],
    }
    transfers.forEach((t) => {
        t.detail.forEach((d) => {
            details.rows.push([t.number, gregorianToJalali(t.date), d.title, d.percent, d.amount, d.treasury_document, d.budget])
        })
    })

    const documents = {
        caption: 'اسناد حسابداری حواله‌ها',
        headers: ['شماره حواله', 'سال مالی سند', 'شماره سند', 'تاریخ سند', 'حساب معین', 'بدهکار', 'بستانکار', 'سال مالی حواله', 'شماره حواله سند', 'تاریخ حواله سند', 'شماره صورت وضعیت', 'نوع صورت وضعیت', 'شماره چک', 'تاریخ صدور چک', 'تاریخ وصول چک', 'مبلغ چک', 'حساب گیرنده وجه', 'شرح پرداخت'],
        rows: [],
    }
    transfers.forEach((t) => {
        t.documents.forEach((d) => {
            documents.rows.push([t.number, d.fiscal_year, d.number, gregorianToJalali(d.date), d.account_subcoding, d.debtor, d.creditor, d.transfer_fiscal_year, d.transfer_number, gregorianToJalali(d.transfer_date), d.request_number, d.request_type, d.cheque_number, gregorianToJalali(d.cheque_date), gregorianToJalali(d.cheque_collected_date), d.cheque_amount, d.account_number, d.remark])
        })
    })

    const title = `حواله‌ها — ${contract && contract.contractee ? contract.contractee : ''}${contract && contract.number ? ' | قرارداد ' + contract.number : ''}`
    // ردیف جمع طلایی — جمع ستونهای مالی
    const num = (v) => (Number(v) || 0)
    const sumCol = (idx) => transfers.reduce((acc, t) => acc + num([
        undefined, t.fiscal_year, t.number, t.date, t.document_number, t.document_date,
        t.request_number, t.request_type, t.remark, t.cash_or_document, t.treasury_document,
        t.amount, t.insurance, t.value_added_tax, t.prepayment, t.back_prepayment,
        t.service_life_prepayment, t.on_account, t.back_on_account, t.deduction_sum, t.receiver,
    ][idx]), 0)
    exportExcelMulti({
        filename: 'transfers.xlsx',
        title,
        headers: main.headers,
        notes: reportMetaNotes(),
        qrDataUri: qr,
        sections: [
            {
                ...main,
                totalRow: (() => {
                    const tr = main.headers.map(() => '')
                    tr[0] = 'جمع'
                    tr[11] = sumCol(11) // مبلغ
                    tr[12] = sumCol(12) // بیمه
                    tr[13] = sumCol(13) // مالیات بر ارزش افزوده
                    tr[14] = sumCol(14) // پیش پرداخت
                    tr[15] = sumCol(15) // تسویه پیش پرداخت جاری
                    tr[16] = sumCol(16) // تسویه پیش پرداخت سنواتی
                    tr[17] = sumCol(17) // علی الحساب
                    tr[18] = sumCol(18) // تسویه علی الحساب
                    tr[19] = sumCol(19) // جمع کسورات
                    return tr
                })(),
            },
            details,
            documents,
        ],
    })
}

// بدون فارسی‌سازی سلول قرار می‌گیرد تا در اکسل قابل محاسبه باشد
const toFarsiDigitValue = v => v

const Transfers = props => {
    const transfers = useRecoilValue(transfersState)
    const userInfo = useRecoilValue(userInfoState)
    const contract = props.contract

    const extract = useMemo(() => ({
        year: (t) => t.fiscal_year,
        search: (t) => [
            t.number, t.fiscal_year, t.document_number, t.document_date, t.request_number,
            t.request_type, t.remark, t.cash_or_document, t.treasury_document,
            t.amount, t.insurance, t.value_added_tax, t.prepayment, t.deduction_sum, t.receiver,
        ],
    }), [])
    const { search, setSearch, year, setYear, years, filtered } = useReportFilter(transfers, extract)

    // رندرِ تدریجی — یک قرارداد می‌تواند تا ۲٬۵۸۳ حواله داشته باشد
    const { visible, hasMore, loadMore, remaining } = useIncrementalList(filtered, {
        step: 50,
        resetKey: `${search}|${year}`,
    })

    // در موبایل، جعبهٔ اسکرولِ تودرتو حذف می‌شود
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <Box>
            {userInfo.is_subscribed && transfers.length > 0 && (
                <>
                    <ReportToolbar
                        search={search} setSearch={setSearch}
                        year={year} setYear={setYear} years={years}
                        rowsCount={transfers.length} filteredCount={filtered.length}
                    />
                    <Box style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 8 }}>
                        <Button variant='contained' color='secondary' onClick={() => exportTransfersExcel(contract, filtered)}>
                            دانلود اکسل
                        </Button>
                    </Box>
                </>
            )}
            <TableContainer
                elevation={5}
                component={Paper}
                style={isMobile ? undefined : { maxHeight: '450px' }}
            >
            <Table stickyHeader={!isMobile}>
                <TableHead>
                    <TableRow>
                        <TableCell align='center'><strong>جزئیات</strong></TableCell>
                        <TableCell align='center'><strong>سند حسابداری</strong></TableCell>
                        <TableCell align='center'><strong>ردیف</strong></TableCell>
                        <TableCell align='center'><strong>سال مالی</strong></TableCell>
                        <TableCell align='center'><strong>شماره حواله</strong></TableCell>
                        <TableCell align='center'><strong>تاریخ</strong></TableCell>
                        <TableCell align='center'><strong>شماره سند حسابداری</strong></TableCell>
                        <TableCell align='center'><strong>تاریخ سند حسابداری</strong></TableCell>
                        <TableCell align='center'><strong>شماره صورت وضعیت</strong></TableCell>
                        <TableCell align='center'><strong>نوع صورت وضعیت</strong></TableCell>
                        <TableCell align='center'><strong>شرح</strong></TableCell>
                        <TableCell align='center'><strong>نقد/اسناد</strong></TableCell>
                        <TableCell align='center'><strong>اسناد خزانه</strong></TableCell>
                        <TableCell align='center'><strong>مبلغ</strong></TableCell>
                        <TableCell align='center'><strong>بیمه</strong></TableCell>
                        <TableCell align='center'><strong>مالیات بر ارزش افزوده</strong></TableCell>
                        <TableCell align='center'><strong>پیش پرداخت</strong></TableCell>
                        <TableCell align='center'><strong>تسویه پیش پرداخت جاری</strong></TableCell>
                        <TableCell align='center'><strong>تسویه پیش پرداخت سنواتی</strong></TableCell>
                        <TableCell align='center'><strong>علی الحساب</strong></TableCell>
                        <TableCell align='center'><strong>تسویه علی الحساب</strong></TableCell>
                        <TableCell align='center'><strong>جمع کسورات</strong></TableCell>
                        <TableCell align='center'><strong>گیرنده</strong></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {visible.map((data, index) => (<Row key={data.id} data={data} index={index + 1} />))}
                </TableBody>
            </Table>
        </TableContainer>
        <LoadMoreButton hasMore={hasMore} remaining={remaining} onClick={loadMore} />
        </Box>
    )
}
export default Transfers